export const FOOTER_HEIGHT = 58;
export const HEADER_HEIGHT = 64;
